import React from 'react';
import { Avatar, Box, Stack, Typography } from '@mui/joy';
import { motion } from 'framer-motion';
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined';

const DotAnimation = ({ delay }) => (
  <motion.span
    style={{
      width: 8,
      height: 8,
      borderRadius: '50%',
      backgroundColor: 'currentColor',
      display: 'inline-block',
    }}
    animate={{
      y: [0, -6, 0],
      opacity: [0.4, 1, 0.4],
    }}
    transition={{
      duration: 0.8,
      repeat: Infinity,
      delay,
      ease: 'easeInOut',
    }}
  />
);

const TypingIndicator = ({ message = 'Thinking' }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -10 }}
      transition={{ duration: 0.3 }}
    >
      <Stack
        direction="row"
        gap={2}
        sx={{
          mb: 3,
          alignItems: 'flex-start',
        }}
      >
        {/* AI Avatar */}
        <Avatar
          size="sm"
          sx={{
            background: (theme) =>
              `linear-gradient(135deg, ${theme.vars.palette.primary[400]} 0%, ${theme.vars.palette.primary[600]} 100%)`,
            color: 'white',
            flexShrink: 0,
            boxShadow: 'sm',
          }}
        >
          <SmartToyOutlinedIcon sx={{ fontSize: 20 }} />
        </Avatar>

        {/* Typing Content */}
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            px: 2,
            py: 1.5,
            bgcolor: 'neutral.50',
            borderRadius: 'lg',
            borderTopLeftRadius: 4,
          }}
        >
          <Typography
            level="body-sm"
            sx={{
              color: 'text.secondary',
              fontStyle: 'italic',
            }}
          >
            {message}
          </Typography>
          
          <Stack
            direction="row"
            gap={0.5}
            sx={{ color: 'neutral.500' }}
          >
            <DotAnimation delay={0} />
            <DotAnimation delay={0.15} />
            <DotAnimation delay={0.3} />
          </Stack>
        </Box>
      </Stack>
    </motion.div>
  );
};

export default TypingIndicator;
